var $ = require('jquery');
var ko = require('knockout');
var LiteratureReviewViewModel = require('./literature-review.vm.js');

$(function () {
    $('.ws-literature-review').each(function (index, item) {
        ko.applyBindings(new LiteratureReviewViewModel(item), item);
    });

    $('.ws-literature-review .ws-form').submit(function () {

        if ($(this).valid()) {
            sessionStorage.removeItem("literatureCart");
        };
    });
});